import React, { useEffect, useState } from "react";
import ProfileHeader from "../../../components/profile-header";
import { Container, Row } from "react-bootstrap";
import profilebg8 from "../../../assets/images/page-img/profile-bg8.jpg";
import { useParams } from "react-router-dom";
import AXIOSCONFIGMETHOD from "../../../components/apiCall/axiosConfig";
import { webServiceUrl } from "../../../components/apiCall/webserviceurl";
import { toast, ToastContainer } from "react-toastify";

export default function Pre_Feedback() {
  const users = JSON.parse(localStorage.getItem("users") || "[]"); // defaults to empty array
  const { school_code } = useParams();
  const [ques, setQues] = useState([]);
  const getQues = async () => {
    try {
      const resp = await AXIOSCONFIGMETHOD(
        "POST",
        webServiceUrl.student_feedback_ques,
      );
      setQues(resp?.data?.data);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    getQues();
  }, []);

  const [formData, setFormData] = useState({
    student_id: localStorage.getItem("userId"),
    student_name: localStorage.getItem("username"),
    school_code: school_code,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  console.log(formData);

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log("Submitted data:", formData);

    try {
      const resp = await AXIOSCONFIGMETHOD(
        "POST",
        webServiceUrl.feedback_form,
        formData,
      );

      if (resp?.success) {
        toast.success(
          resp?.message || resp?.data?.message || "Submitted successfully",
        );
      } else {
        toast.error(resp?.message || "Something went wrong");
      }
    } catch (error) {
      console.error("Submit error:", error);
      toast.error(error?.message || "Submission failed. Please try again.");
    }
  };

  return (
    <>
      <ProfileHeader img={profilebg8} />
      <ToastContainer />
      <div
        id="content-page"
        className="content-inner store-details upcoming-card pt-4 mt-0"
      >
        <Container>
          <Row>
            <form onSubmit={handleSubmit} className="container p-4">
              <div className="row">
                {/* Left Column (3 questions) */}
                <div className="row">
                  {ques.map((item, index) => (
                    <div key={index} className="col-md-6 mb-4">
                      <fieldset className="mb-4">
                        <legend className="fw-semibold mb-3">
                          {index + 1}. {item?.question}
                        </legend>
                        {[
                          item?.opt_1,
                          item?.opt_2,
                          item?.opt_3,
                          item?.opt_4,
                        ].map((option) => (
                          <div className="form-check mb-2" key={option}>
                            <input
                              className="form-check-input"
                              type="radio"
                              name={`q${index + 1}`}
                              id={`q${index + 1}-${option}`}
                              value={option}
                              checked={formData[`q${index + 1}`] === option}
                              onChange={handleChange}
                              required
                            />
                            <label
                              className="form-check-label"
                              htmlFor={`q${index + 1}-${option}`}
                            >
                              {option}
                            </label>
                          </div>
                        ))}
                      </fieldset>
                    </div>
                  ))}
                </div>

                {/* Right Column (2 questions) */}
                {/* <div className="col-md-6 mb-4">
      <fieldset className="mb-4">
        <legend className="fw-semibold mb-3">
          4. How useful were the hands-on activities and practical sessions (e.g., coding exercises, AI demos, lab visits)?
        </legend>
        {["Very Useful", "Useful", "Neutral", "Not Useful"].map((option) => (
          <div className="form-check mb-2" key={option}>
            <input
              className="form-check-input"
              type="radio"
              name="q4"
              id={`q4-${option}`}
              value={option}
              checked={formData.q4 === option}
              onChange={handleChange}
              required
            />
            <label className="form-check-label" htmlFor={`q4-${option}`}>
              {option}
            </label>
          </div>
        ))}
      </fieldset>

      <fieldset className="mb-4">
        <legend className="fw-semibold mb-3">
          5. To what extent did the training encourage collaboration and active participation?
        </legend>
        {[
          "To a Great Extent",
          "To Some Extent",
          "Very Little",
          "Not at All",
        ].map((option) => (
          <div className="form-check mb-2" key={option}>
            <input
              className="form-check-input"
              type="radio"
              name="q5"
              id={`q5-${option}`}
              value={option}
              checked={formData.q5 === option}
              onChange={handleChange}
              required
            />
            <label className="form-check-label" htmlFor={`q5-${option}`}>
              {option}
            </label>
          </div>
        ))}
      </fieldset>
    </div> */}
              </div>

              <button type="submit" className="btn btn-primary">
                Submit
              </button>
            </form>
          </Row>
        </Container>
      </div>
    </>
  );
}
